const Visa = () => {
  return (
    <svg
      width="34"
      height="16"
      viewBox="0 0 34 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="32.8889" height="15" rx="3.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="32.8889"
        height="15"
        rx="3.5"
        stroke="#CFCFCF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2749 3.87091C22.8293 3.69463 22.1225 3.5 21.2486 3.5C19.0176 3.5 17.4465 4.68629 17.4369 6.38232C17.4184 7.63364 18.5617 8.32866 19.4169 8.74589C20.2909 9.17224 20.588 9.45052 20.588 9.83055C20.5791 10.4142 19.8818 10.6832 19.2313 10.6832C18.3293 10.6832 17.8461 10.5445 17.1116 10.2198L16.8141 10.0806L16.498 12.0363C17.0278 12.277 18.0041 12.4906 19.0176 12.5C21.3881 12.5 22.9314 11.3321 22.9497 9.52468C22.9587 8.53291 22.3549 7.77297 21.0533 7.15198C20.2631 6.75335 19.7792 6.48456 19.7792 6.07669C19.7885 5.7059 20.1885 5.32612 21.0805 5.32612C21.8149 5.30751 22.3546 5.48355 22.7634 5.6597L22.9677 5.75222L23.2749 3.87091ZM15.0852 12.3702H12.826L14.239 3.65793H16.4981L15.0852 12.3702ZM27.1796 6.84612C27.1796 6.84612 26.4637 8.78322 26.2776 9.28373H28.1554C28.0625 8.84814 27.6347 6.76272 27.6347 6.76272L27.4768 6.01202C27.4104 6.20517 27.3143 6.47065 27.2495 6.6499L27.2493 6.65043L27.2492 6.65071C27.2053 6.77203 27.1758 6.85362 27.1796 6.84612ZM27.3188 3.65793H29.0663L30.8889 12.37H28.7971C28.7971 12.37 28.5924 11.369 28.5275 11.0632H25.6269C25.543 11.2947 25.1528 12.37 25.1528 12.37H22.7823L26.138 4.38079C26.3705 3.81536 26.7799 3.65793 27.3188 3.65793ZM10.939 3.65793L8.7265 9.59884L8.48473 8.39395C8.48465 8.3937 8.48458 8.39344 8.4845 8.39318L7.69456 4.39027C7.56447 3.83384 7.16469 3.67628 6.67201 3.65793H3.03719L3 3.83396C3.88652 4.06001 4.67943 4.38575 5.37419 4.79076L7.38781 12.3609H9.77684L13.3279 3.65793H10.939Z"
        fill="#1434CB"
      />
    </svg>
  );
};
export default Visa;
